import { createContext, useContext, useState } from "react";

interface MobileMenuContextType {
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
}

const MobileMenuContext = createContext<MobileMenuContextType>({
  menuOpen: false,
  setMenuOpen: () => {},
});

export function MobileMenuProvider({ children }: { children: React.ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <MobileMenuContext.Provider value={{ menuOpen, setMenuOpen }}>
      {children}
    </MobileMenuContext.Provider>
  );
}

export const useMobileMenu = () => useContext(MobileMenuContext);
